<template name="create">
  <div class="draft bg-white" :style="{minHeight:minHeight+'px'}">
    
  </div>
</template>

<script>
  import headerCom from '../header.vue'
  export default {
    name: 'create',
    data(){
      return {
          minHeight:window.innerHeight-82
      }
    },
    components:{
      headerCom
    },
    methods:{

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/list/create.vue